// internationalization
import type { TFunction } from 'i18next';

// api
import type { Building, Topic } from '@/api/generated/daluxfm/daluxfm';

// libraries
import { z } from 'zod';

export type DaluxBuildingOption = NonNullable<Building>;
export type DaluxTopicOption = NonNullable<Topic>;

const isBrowserFile = (value: unknown) =>
  value === null || (typeof File !== 'undefined' && value instanceof File);

export function createDaluxTicketFormSchema(t: TFunction) {
  return z.object({
    description: z
      .string()
      .trim()
      .min(1, t('ticket.validation.description_required')),
    reporterName: z.string(),
    reporterEmail: z.string(),
    photo: z.custom<File | null>(isBrowserFile).nullable(),
    topicId: z.string().nullable(),
    buildingId: z
      .string()
      .nullable()
      .refine(
        (buildingId) => !!buildingId,
        t('ticket.validation.building_required'),
      ),
  });
}

export type DaluxTicketFormValues = z.infer<
  ReturnType<typeof createDaluxTicketFormSchema>
>;
